const DACHSER_TENANT_ID = 5460530;

const UNIDADE_NEGOCIO_PADRAO = '101';

const UNIDADES_NEGOCIO = [
  { value: '101', label: '101 - Campinas' },
  { value: '104', label: '104 - Guarulhos' },
  { value: '105', label: '105 - Santos' },
  { value: '121', label: '121 - Curitiba' },
  { value: '201', label: '201 - São Paulo' },
  { value: '220', label: '220 - Porto Alegre' },
];

const isDachserTenant = (tenant) => Number(tenant) === DACHSER_TENANT_ID;

const getLabelByValue = (value) => {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  const found = UNIDADES_NEGOCIO.find((unidade) => unidade.value === String(value));

  return found?.label || String(value);
};

const UnidadeNegocioDachserUtils = {
  DACHSER_TENANT_ID,
  UNIDADE_NEGOCIO_PADRAO,
  UNIDADES_NEGOCIO,
  isDachserTenant,
  getLabelByValue,
};

export default UnidadeNegocioDachserUtils;
